import BaseService from "./BaseService";

const BASE = "saved-reports";

// namePattern: the list's search (report name contains it, any case); none
// lists every saved report.
export const getSavedReports = (namePattern) =>
  BaseService.callAPI(
    namePattern ? `${BASE}?${new URLSearchParams({ namePattern })}` : BASE
  );

export const getSavedReport = (id) => BaseService.callAPI(`${BASE}/${id}`);

export const createSavedReport = (body) =>
  BaseService.callAPI(BASE, "POST", body);

export const updateSavedReport = (id, body) =>
  BaseService.callAPI(`${BASE}/${id}`, "PUT", body);

export const deleteSavedReport = (id) =>
  BaseService.callAPI(`${BASE}/${id}`, "DELETE");

export const saveSchedule = (id, body) =>
  BaseService.callAPI(`${BASE}/${id}/schedule`, "PUT", body);

export const pauseSchedule = (id) =>
  BaseService.callAPI(`${BASE}/${id}/schedule/pause`, "POST");

export const resumeSchedule = (id) =>
  BaseService.callAPI(`${BASE}/${id}/schedule/resume`, "POST");

export const deleteSchedule = (id) =>
  BaseService.callAPI(`${BASE}/${id}/schedule`, "DELETE");

export const sendNow = (id) =>
  BaseService.callAPI(`${BASE}/${id}/send-now`, "POST");

export const getHistory = (id) => BaseService.callAPI(`${BASE}/${id}/history`);

export const downloadReportFile = (logId) =>
  BaseService.callAPI(`${BASE}/downloads/${logId}`, "GET", null, {
    responseType: "blob",
  });
